import React, { Component } from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobeAmericas } from '@fortawesome/free-solid-svg-icons';
import { FormattedHTMLMessage } from 'react-intl';
import config from '../../config';

import './styles.scss';

import logo from '../../assets/img/logo-emmaby-axa-shadow-darkblue-horizontal.png';

library.add(faGlobeAmericas);


class Header extends Component {
  componentDidMount() {
  }

  getOppositeLang() {
    const lang = this.getLanguage();
    return lang === 'en' ? 'zh' : 'en';
  }

  getOppositeLangLabel() {
    const lang = this.getLanguage();
    return lang === 'en' ? '中文' : 'EN';
  }

  getLanguage() {
    return window.location.pathname.split('/').find(s => !!s) || 'en';
  }

  getChangeLangHref() {
    const lang = this.getLanguage();
    const oppositeLang = this.getOppositeLang();
    const currentBaseUrl = window.location.origin;
    const currentPathName = window.location.pathname;
    const newPath = currentPathName.replace(lang, oppositeLang);
    const changeLanguageHref = currentBaseUrl + newPath;

    return changeLanguageHref;
  }

  changeLang() {
    window.location.href = this.getChangeLangHref();
  }

  logout() {
    // const {onSignOut} = this.props;
    // onSignOut();
    // window.location.href = getBaseUrl();
  }
  gotoEmmaWelcomePage() {
    const lang = this.getLanguage();
    const oppositeLang = this.getOppositeLang();
    window.location.href = config.signInRedirectUrl.replace(oppositeLang, lang);
  }

  render() {
    // const { token } = this.props;

    return (
      <div>
        {!config.isApp &&
        <div className="emma-identity-header">
          <header key={'header'}>
            <div>
              <a href={`https://www.axa.com.hk/${this.getLanguage()}/`}>
                <FormattedHTMLMessage id="emma.header.go-back-to" />
              </a>
            </div>
            <div>
            <div className="v-sp" />
            <a className="contact-us"
                href={`https://www.axa.com.hk/${this.getLanguage()}/contact-us`}
                onClick={() => this.changeLang()}
            >
                <FormattedHTMLMessage id="emma.header.contact-us" />
            </a>
            <div className="v-sp" />
            <button
                onClick={() => this.changeLang()}
                className="emma-identity-header__button"
            >
                <FontAwesomeIcon icon="globe-americas" />
                <span>{this.getOppositeLangLabel()}</span>
            </button>
            </div>
          </header>
          <nav key={'nav'}>
              <div onClick={() => { this.gotoEmmaWelcomePage(); }} className="nav-img" onKeyUp={() => {}}>
                  <img src={logo} alt="" />
              </div>
              <div />
          </nav>
        </div>
        }
      </div>
    );
  }
}

export default (Header);
